import React from 'react'
import { Controller, FieldError } from 'react-hook-form'
import { Content, Error, FieldColor, Label } from './styles'

export interface InputColorProps {
  control: any
  label?: string
  error?: FieldError
  disabled?: boolean
  name: string
}

const InputColor: React.FunctionComponent<InputColorProps> = ({
  control,
  label,
  disabled,
  error,
  name,
}) => {
  return (
    <Controller
      key={name}
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value } }) => {
        const handleOnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
          let value = e.target.value
          onChange(value)
        }

        return (
          <Content>
            <FieldColor
              disabled={disabled}
              value={value}
              error={!!error}
              onBlur={onBlur}
              onChange={handleOnChange}
              type={'color'}
            />
            {label && <Label>{label}</Label>}
            {error && <Error>{error.message}</Error>}
          </Content>
        )
      }}
    />
  )
}

export default InputColor
